import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const fragment = window.location.hash.slice(1);
        const params = new URLSearchParams(fragment);
        const sessionId = params.get("session_id");

        if (!sessionId) {
            navigate("/login");
            return;
        }

        (async () => {
            try {
                const data = await api.post("/auth/session", { session_id: sessionId });
                setUser(data.user);
                window.history.replaceState({}, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: data.user } });
            } catch (e) {
                console.error("Auth failed", e);
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen bg-ink-900 flex items-center justify-center">
            <div className="text-gray-400 text-sm">Signing you in…</div>
        </div>
    );
}
